// Copyright (C) 2020 Intel Corporation
//
// SPDX-License-Identifier: MIT

import React from 'react';
import { connect } from 'react-redux';
import Modal from 'antd/lib/modal';
import Title from 'antd/lib/typography/Title';

import { changePasswordAsync, changeEmailAsync } from 'actions/auth-actions';
import { CombinedState } from 'reducers/interfaces';
import ChangePasswordForm, { ChangePasswordData } from './change-password-form';
import ChangeEmailForm, { ChangeEmailData } from './change-email-form'

interface StateToProps {
    fetching: boolean;
    visible: boolean;
    flag: "password" | "email"
}

interface DispatchToProps {
    onChangePassword(
        arg: {
            oldPassword: string,
            newPassword1: string,
            newPassword2: string
        }): void;
    onChangeEmail(
        arg: {
            oldEmail: string,
            newEmail: string,
            token: string
        }
    ): void
}

interface ChangePageComponentProps {
    visible: boolean;
    onClose(): void;
    onChange(arg: any): void;
    Form: JSX.Element;
    title: string;
}

interface ChangePasswordPageComponentProps {
    fetching: boolean;
    visible: boolean;
    flag: "password" | "email";
    onClose(): void;
    onChangePassword: (args: { oldPassword: string, newPassword1: string, newPassword2: string }) => void;
}

interface ChangeEmailPageComponentProps {
    fetching: boolean;
    visible: boolean;
    flag: "password" | "email";
    onClose(): void;
    onChangeEmail: (args: ChangeEmailData) => void;
}

function mapStateToProps(state: CombinedState): StateToProps {
    return {
        fetching: state.auth.fetching,
        visible: state.auth.showChangeDialog,
        flag: state.auth.dialogFlag
    };
}

function mapDispatchToProps(dispatch: any): DispatchToProps {
    return ({
        onChangePassword({ oldPassword, newPassword1, newPassword2 }: { oldPassword: string, newPassword1: string, newPassword2: string }): void {
            dispatch(changePasswordAsync(oldPassword, newPassword1, newPassword2));
        },
        onChangeEmail({ oldEmail, newEmail, token }: ChangeEmailData): void {
            dispatch(changeEmailAsync(oldEmail, newEmail, token))
        }
    });
}

function ChangeComponent(props: ChangePageComponentProps): JSX.Element {
    const {
        // fetching,
        // onChange,
        visible,
        onClose,
        Form,
        title,
    } = props;

    return (
        <Modal
            title={<Title level={3}>{title}</Title>}
            okType='primary'
            okText='Submit'
            footer={null}
            visible={visible}
            destroyOnClose
            onCancel={onClose}
        >
            {/* <ChangePasswordForm
                onSubmit={(changePasswordData: ChangePasswordData): void => {
                    onChangePassword(
                        changePasswordData.oldPassword,
                        changePasswordData.newPassword1,
                        changePasswordData.newPassword2,
                    );
                }}
                fetching={fetching}
            /> */}
            {Form}
        </Modal>
    );
}

function ChangePassword(props: ChangePasswordPageComponentProps) {
    const {
        fetching,
        onChangePassword,
        visible,
        onClose,
        flag
    } = props;
    return (<>
        <ChangeComponent
            {...{ fetching, visible: visible && flag === "password", onClose }}
            Form={<ChangePasswordForm
                onSubmit={(changePasswordData: ChangePasswordData): void => {
                    onChangePassword(changePasswordData);
                }}
                fetching={fetching}
            />}
            onChange={onChangePassword}
            title="Change Password"
        />
    </>)
}

function ChangeEmail(props: ChangeEmailPageComponentProps) {
    const {
        fetching,
        onChangeEmail,
        visible,
        onClose,
        flag
    } = props;
    return (<>
        <ChangeComponent
            {...{ fetching, visible: visible && flag === "email", onClose }}
            Form={<ChangeEmailForm
                onSubmit={(changeEmailData: ChangeEmailData): void => {
                    onChangeEmail(changeEmailData);
                }}
                fetching={fetching}
            />}
            onChange={onChangeEmail}
            title="Change Email"
        />
    </>)
}

export const ChangePasswordComponent = connect(
    mapStateToProps,
    mapDispatchToProps,
)(ChangePassword);

export const ChangeEmailComponent = connect(
    mapStateToProps,
    mapDispatchToProps,
)(ChangeEmail);
